import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from 'react-modal';
import SVGInline from 'react-svg-inline';

// Icons
import closeIcon from 'assets/icon-close.svg';

// Styles
import styles from './modalMenu.scss';

class ModalMenu extends Component {
  /**
   * Construct the component.
   * @param  {object} props Component props.
   * @return {void}
   */
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
    };

    // Bind methods
    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * Invoked immediately after updating occurs.
   * @param  {object} prevProps Previous props.
   * @param  {object} prevState Previous state.
   * @return {void}
   */
  componentDidUpdate(prevProps, prevState) {
    /**
     * If the menu is currently open and it has been open, then the menu should
     * close. For example, when opening the menu and navigating to another
     * view in the application from the menu.
     *
     * This works because navigating to a new page will update the props for
     * this component.
     */
    if (prevState.menuIsOpen && this.state.menuIsOpen) {
      this.handleClick();
    }
  }

  /**
   * Given a value, will set the menuIsOpen to either that value or, if they
   * match, false.
   * @param  {string} value Value to check.
   * @return {void}
   */
  handleClick() {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  }

  /**
   * Render the component
   * @return {object} Component jsx
   */
  render() {
    const {
      children,
      label,
      buttonClassName,
      title,
    } = this.props;
    const modalTitle = '' === title ? label : title;
    return (
      <nav className={styles.modalMenu}>
        <button
          className={classNames(styles.button, buttonClassName)}
          onClick={this.handleClick}
          aria-expanded={this.state.menuIsOpen}
          aria-haspopup
        >
          {label}
        </button>
        <Modal
          isOpen={this.state.menuIsOpen}
          onRequestClose={this.handleClick}
          contentLabel={label}
          overlayClassName={{
            base: styles.overlay,
            afterOpen: '',
            beforeClose: '',
          }}
          className={{
            base: styles.modal,
            afterOpen: styles.modalAfterOpen || '',
            beforeClose: styles.modalBeforeClose || '',
          }}
          ariaHideApp={false}
        >
          <div className={styles.contents}>
            <h2 className={styles.title}>
              {modalTitle}
            </h2>
            <button
              onClick={this.handleClick}
              className={styles.closeButton}
            >
              <span className="screen-reader-text">
                Close this modal
              </span>
              <SVGInline
                svg={closeIcon}
                className={styles.icon}
                cleanup
              />
            </button>
            {children}
          </div>
        </Modal>
      </nav>
    );
  }
}

ModalMenu.defaultProps = {
  buttonClassName: '',
  title: '',
};

ModalMenu.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string,
  title: PropTypes.string,
};

export default ModalMenu;



// WEBPACK FOOTER //
// ./app/components/modalMenu/index.js